<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="container pt-40-25">
      <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>

      <div class="pb-300-100">
        @if (listOfLeagues.length) {
        <app-league-grid-list [leagues]="listOfLeagues"
                              (scrolled)="loadMore()"
                              (onRightButtonClickCallback)="goToSeriesDetailsPage($event)"
                              [languages]="languages"/>
        }
        @else {
        <div class="py-10">
          <app-empty-state/>
        </div>
        }
      </div>
    </div>
  </app-page-template>

  <ng-template #searchFrom>
    <div class="mb-3">
      <app-filter-panel [groups]="filterGroups"
                        [searchTermParam]="'name'"
                        (filterChange)="onFilterChange($event)"
                        [handleQueryParams]="true"
                        [showFilterChips]="false"/>
    </div>
  </ng-template>

</ng-container>
